import uri from "refractor/uri";
export default uri;